export default __webpack_public_path__ + "static/media/Amber 9781843620174.7c821776.jpg";